import { render, staticRenderFns } from "./candidateInformationAdditional.vue?vue&type=template&id=5b8f83bd&"
import script from "./candidateInformationAdditional.vue?vue&type=script&lang=js&"
export * from "./candidateInformationAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports